module.exports = __webpack_public_path__ + "static/img/pdp-cart.528f63eb.svg";